module.exports = __webpack_public_path__ + "img/Dashboard.d69cebaa.png";